/* eslint-disable no-unreachable */
import _get from 'lodash/get';
import deepmerge from 'deepmerge';
import { getChildFilters, selectFilter, setFilterTouched } from './helpers';
export default (state, action, _ref) => {
  let {
    types
  } = _ref;
  switch (action.type) {
    case types.ADD_ERROR:
      {
        const {
          errorMessage,
          filter
        } = action.payload;
        return {
          ...state,
          errors: {
            ...state.errors,
            [filter.name]: errorMessage
          }
        };
      }
    case types.ADD_FILTERS_OPTIONS:
      {
        return {
          ...state,
          options: deepmerge.all([{}, state.options, action.payload], {
            arrayMerge: (s, d, o) => d
          })
        };
        break;
      }
    case types.CLEAR_LAST_TOUCHED_FILTER:
      {
        return {
          ...state,
          lastTouched: null
        };
        break;
      }
    case types.DESELECT_FILTER:
      {
        const {
          value,
          filter,
          isMultiple
        } = action.payload;
        const newValuesState = {
          ...state.values
        };

        // Deselecting only makes sense for multi-select controls
        // TODO: should this return a clear value then?
        if (!isMultiple) {
          return newValuesState;
        }

        // ensure an array and then filter out the deslected value
        const newFilterValue = [].concat(newValuesState[filter.name].value).filter(_value => _value !== value);

        // Only update the value of the filter if there is one else remove it completely
        if (newFilterValue.length > 0) {
          newValuesState[filter.name] = {
            ...newValuesState.filterName,
            value: newFilterValue
          };
        } else {
          delete newValuesState[filter.name];
        }

        // If the deselected filter is the parent of any multifilter
        // we must remove all those multi-filter values as well
        getChildFilters(newValuesState, value).forEach(childFilter => delete newValuesState[childFilter]);
        return {
          ...state,
          lastTouched: filter.name,
          touched: setFilterTouched(state, filter.name),
          values: newValuesState
        };
        break;
      }
    case types.CLEAR_ACTIVE_EXPANSION:
      {
        return {
          ...state,
          activeExpansion: []
        };
      }
    case types.CLEAR_FILTER:
      {
        const newValuesState = {
          ...state.values
        };
        const filterName = action.payload;
        const clearedFilter = _get(newValuesState, [filterName], {});
        if (!clearedFilter.protected) {
          delete newValuesState[filterName];
        }
        return {
          ...state,
          lastTouched: filterName,
          touched: setFilterTouched(state, filterName),
          values: newValuesState
        };
        break;
      }
    case types.CLEAR_FILTERS:
      {
        let newValuesState = {
          ...state.values
        };

        // If an array is passed as the action payload then we
        // assume want to clear several filters at once.
        // If there is not an Array or there is no payload then we
        // assume we want to clear all filters
        if (Array.isArray(action.payload)) {
          // clear requested filters unless it is protected
          action.payload.forEach(filterName => {
            const clearedFilter = _get(newValuesState, [filterName], {});
            if (!clearedFilter.protected) {
              delete newValuesState[filterName];
            }
          });
        } else {
          // reduce the values object to only protected values
          newValuesState = Object.keys(newValuesState).reduce((acc, key) => {
            const isProtected = _get(newValuesState, [key, 'protected'], false);
            if (isProtected) {
              acc[key] = newValuesState[key];
            }
            return acc;
          }, {});
        }
        return {
          ...state,
          values: newValuesState
        };
        break;
      }
    case types.HIDE_FILTERS:
      {
        return {
          ...state,
          visible: false
        };
        break;
      }
    case types.REMOVE_ACTIVE_EXPANSION:
      {
        return {
          ...state,
          activeExpansions: state.activeExpansions.filter(item => item !== action.payload)
        };
      }
    case types.REMOVE_ERROR:
      {
        const {
          filter
        } = action.payload;
        const errorState = {
          ...state.errors
        };

        // remove the deleted error state
        delete errorState[filter.name];
        return {
          ...state,
          errors: errorState
        };
        break;
      }
    case types.SELECT_FILTER:
      {
        const filterName = _get(action, 'payload.filter.name');
        return {
          ...state,
          lastTouched: filterName,
          touched: setFilterTouched(state, filterName),
          values: {
            ...state.values,
            ...selectFilter(state.values, action.payload)
          }
        };
        break;
      }
    case types.SELECT_FILTERS:
      {
        const newValues = action.payload.reduce((acc, item) => {
          const updatedFilter = selectFilter(state.values, item);
          acc[item.filter.name] = updatedFilter[item.filter.name];
          return acc;
        }, {});
        return {
          ...state,
          values: {
            ...state.values,
            ...newValues
          }
        };
        break;
      }
    case types.SET_ACTIVE_EXPANSION:
      {
        let activeExpansions = [...state.activeExpansions];
        if (!activeExpansions.includes(action.payload)) {
          activeExpansions = [...state.activeExpansions, action.payload];
        }
        return {
          ...state,
          activeExpansions
        };
      }
    case types.SHOW_FILTERS:
      {
        return {
          ...state,
          visible: true
        };
        break;
      }
    case types.SET_FILTERS_OPTIONS:
      {
        return {
          ...state,
          options: action.payload
        };
        break;
      }
    case types.SET_FILTERS_VALUES:
      {
        return {
          ...state,
          values: Object.keys(action.payload).reduce((acc, key) => ({
            ...acc,
            [key]: {
              value: action.payload[key],
              // retain protection
              ...(state.values[key] && state.values[key].protected ? {
                protected: true
              } : {})
            }
          }), {})
        };
        break;
      }
    default:
      return state;
  }
};